<template>
  <div class="recorder-app">
    <!-- 1. 类型选择视图 -->
    <div class="container selection-view" v-if="!typeId">
      <div class="title-wrap">
        <h1 class="title">请选择你想检测的部分</h1>
      </div>
      <div class="card-list">
        <div
          class="card-item"
          :class="'card-bg-' + index"
          v-for="(item, index) in cardList"
          :key="index"
          @click="selectType(item)"
        >
          <div class="card-text">
            <p>{{ item.title }}</p>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. 录音对话视图 -->
    <div class="container chat-view" v-else>
      <div style="height: 10px;"></div>
      <!-- 顶部欢迎语 -->
      <div class="chat-container">
        <div class="chat-message">
          <div class="avatar-container">
            <img src="../assets/mine/tx.png" alt="头像" class="avatar" />
          </div>
          <div class="message-content">
            <div class="message-text">Hi, 我是Luna</div>
            <div class="message-text2">来测试一下你的朗读专业性</div>
            <div class="message-text2">做一个音色测评吧~</div>
          </div>
        </div>
      </div>

      <!-- 话题选择区 -->
      <div class="htTitle">挑选一个你感兴趣的话题吧</div>
      <div class="topic-container">
        <div class="category" v-for="item in topicList" :key="item.articleType">
          <div class="category-title">
            <img class="htimg" src="../assets/mine/ht.png" alt="" />
            {{ item.articleTypeName }}
          </div>
          <div class="topics-grid">
            <div
              v-for="(topic, index) in item.aiOralArticle"
              :key="index"
              @click="handleTopicClick(topic)"
              class="topic-item"
            >
              <div class="topic-text">{{ topic.articleTitle }}</div>
              <img class="arrow" src="../assets/arrow1.png" />
            </div>
          </div>
        </div>
      </div>

      <!-- 对话列表区 -->
      <div class="chat-content">
        <div
          v-for="(item, index) in messageList"
          :key="index"
          class="msg-wrapper"
        >
          <!-- 机器人/系统消息 -->
          <div class="con-left" v-if="item.state === 0 || item.state === 1">
            {{ item.text }}
            <div class="ts" v-if="item.state === 1">
              请在安静的环境下，朗诵以上内容
            </div>
          </div>
          <!-- 用户语音消息 -->
          <div
            class="con-right"
            v-if="item.state === 2"
            @click="playAudio(item)"
          >
            <div>{{ item.time }}"</div>
            <img
              class="con-right-yuyin"
              src="../assets/mine/yuyin.png"
              alt=""
            />
          </div>
        </div>
      </div>

      <!-- 底部录音按钮 -->
      <div
        class="record-button"
        :class="{ recording: isRecording, 'cancel-mode': showCancelHint }"
        @touchstart.prevent="startRecording"
        @touchend.prevent="handleRelease"
        @touchmove.prevent="handleTouchMove"
        @mouseleave="handleLeaveWhileRecording"
      >
        <div class="button-content">{{ buttonText }}</div>
      </div>

      <!-- 音频播放器 (隐藏) -->
      <audio
        v-if="currentAudioUrl"
        autoplay
        :src="currentAudioUrl"
        @ended="handleAudioEnded"
      ></audio>
    </div>

    <!-- 底部占位与 Tabbar -->
    <div style="height: 100px;"></div>
    <FootTab></FootTab>
  </div>
</template>

<script>
import axios from "axios";
import FootTab from "@/components/FootTab.vue";

export default {
  name: "RecorderApp",
  components: { FootTab },
  data() {
    return {
      // 状态管理
      typeId: null, // 当前选中的测评类型
      isRecording: false,
      showCancelHint: false,
      aiflag: true, // 防止频繁请求
      vipFlag: false,
      userFlag: false, // true表示未登录(原有逻辑反直觉，建议后端返回明确字段)

      // 数据列表
      topicList: [], // 话题列表
      messageList: [], // 聊天记录列表
      cardList: [
        {
          id: 1,
          title: "音频内容准确率",
          name: "原始文本和音频内容中文是否完全一致",
        },
        { id: 2, title: "声调规范性", name: "发音是否标准" },
        { id: 3, title: "发音清晰度", name: "咬字是否清晰" },
        { id: 4, title: "语气适配性", name: "语气贴合文本场景" },
        { id: 5, title: "情感契合度", name: "贴合文本语境" },
      ],

      // 录音相关
      currentText: null, // 当前朗读的文本
      currentAudioUrl: null, // 当前播放的音频
      mediaRecorder: null,
      audioChunks: [],
      recordingDuration: 0,
      timer: null,
      stream: null,

      // 交互坐标
      startY: 0,
      currentY: 0,
    };
  },
  computed: {
    buttonText() {
      if (this.showCancelHint) return "松开发送上划取消";
      return this.isRecording
        ? `录音中... ${this.recordingDuration}s`
        : "按住说话";
    },
  },
  created() {
    this.initData();
  },
  methods: {
    // 初始化数据
    async initData() {
      try {
        // 获取话题列表
        const topicRes = await axios.get(
          "https://api.jasdm.cn/ai-platform/anchor/oral/findAll",
          {
            headers: {
              'paper_token': localStorage.getItem("userMes")
                ? eval("(" + localStorage.getItem("userMes") + ")").user_token
                : "",
            },
          }
        );
        this.topicList = topicRes.data.data;

        // 获取用户信息 (假设 this.http 是全局挂载的请求工具)
        const userRes = await this.http.getUserMes();
        console.log("用户信息:", userRes.data);

        if (userRes.data.status == 99) {
          this.userFlag = true; // 未登录
        } else if (userRes.data.data.paperVip) {
          this.vipFlag = true; // 是VIP
        }
      } catch (error) {
        console.error("初始化数据失败:", error);
      }
    },

    // 选择测评类型
    selectType(item) {
      this.typeId = item.id;
    },

    // 点击话题
    handleTopicClick(topic) {
      this.currentText = topic.articleContent;
      this.pushMessage({
        state: 1, // 1: 系统提示朗读
        text: this.currentText,
      });
    },

    // 添加消息并滚动
    pushMessage(msg) {
      this.messageList.push(msg);
      this.$nextTick(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      });
    },

    // 播放录音
    playAudio(item) {
      this.currentAudioUrl = item.url;
    },

    handleAudioEnded() {
      this.currentAudioUrl = null;
    },

    // --- 录音核心逻辑 ---

    async startRecording(e) {
      // 1. 权限与状态检查
      // if (this.userFlag) return this.$message.error('您未登录，请登录后再次操作');
      // if (!this.vipFlag) return this.$message.error('请开通会员');
      if (!this.aiflag || this.isRecording) return;

      // 2. 记录触摸起始点
      if (e.touches) this.startY = e.touches[0].clientY;

      try {
        this.isRecording = true;
        this.showCancelHint = false;

        // 3. 获取麦克风流
        this.stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        });
        this.mediaRecorder = new MediaRecorder(this.stream);
        this.audioChunks = [];

        // 4. 事件监听
        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) this.audioChunks.push(event.data);
        };

        this.mediaRecorder.onstop = this.handleRecordingStop;

        // 5. 开始录制
        this.mediaRecorder.start(100);
        this.startTimer();
      } catch (error) {
        console.error("录音启动失败:", error);
        this.isRecording = false;
        this.$message.error("无法访问麦克风，请检查权限");
      }
    },

    // 录音停止处理
    handleRecordingStop() {
      this.stopTimer();
      this.stopStream();

      // 如果有数据且不是取消操作
      if (this.audioChunks.length > 0 && !this.showCancelHint) {
        const audioBlob = new Blob(this.audioChunks, { type: "audio/wav" });
        const audioUrl = URL.createObjectURL(audioBlob);

        // 上传并显示消息
        this.uploadAudio(audioBlob);
        this.pushMessage({
          state: 2, // 2: 用户语音
          time: this.recordingDuration,
          url: audioUrl,
        });
      }

      // 重置状态
      this.isRecording = false;
      this.showCancelHint = false;
      this.recordingDuration = 0;
    },

    // 上传音频
    uploadAudio(audioBlob) {
      this.aiflag = false;
      const formData = new FormData();
      formData.append("audioFile", audioBlob, "recording.wav");
      formData.append("content", this.currentText);
      formData.append("type", this.typeId);

      const token = localStorage.getItem("userMes")
        ? eval("(" + localStorage.getItem("userMes") + ")").user_token
        : "";

      // 使用 fetch，注意地址用回了线上地址
      fetch("https://api.jasdm.cn/ai-platform/anchor/oral/chat", {
        // fetch('http://192.168.1.116:8090/aiOral/chat', {
        method: "POST",
        body: formData,
        headers: {
          'paper_token': localStorage.getItem("userMes")
            ? eval("(" + localStorage.getItem("userMes") + ")").user_token
            : "",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          console.log("返回的数据:", data);
          this.pushMessage({
            state: 0,
            text: data.data || data.msg,
          });
        })
        .catch((error) => {
          console.error("请求失败:", error);
        })
        .finally(() => {
          this.aiflag = true;
        });
    },

    // --- 交互逻辑 ---

    handleTouchMove(e) {
      if (!this.isRecording) return;
      this.currentY = e.touches[0].clientY;
      // 上划超过 50px 触发取消状态
      this.showCancelHint = this.startY - this.currentY > 50;
    },

    handleRelease() {
      if (!this.isRecording) return;
      // 如果处于取消模式，则不保存
      if (this.showCancelHint) {
        this.mediaRecorder.stop();
        // onstop 中会判断 showCancelHint 来决定是否上传
      } else {
        this.mediaRecorder.stop();
      }
    },

    handleLeaveWhileRecording() {
      if (this.isRecording) {
        this.mediaRecorder.stop();
      }
    },

    // --- 辅助函数 ---
    startTimer() {
      this.recordingDuration = 0;
      this.timer = setInterval(() => {
        this.recordingDuration++;
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    stopStream() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }
    },
  },
  beforeDestroy() {
    this.stopTimer();
    this.stopStream();
  },
};
</script>

<style scoped>
.recorder-app {
  background: #f9fafb;
  min-height: 100vh;
  padding-bottom: 20px;
}

.container {
  margin: 0 auto;
  padding: 0 16px;
}

/* 标题样式 */
.title-wrap {
  margin-bottom: 24px;
  padding: 20px 0 12px;
  border-bottom: 1px solid #e5e7eb;
}

.title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  text-align: center;
}

/* 卡片列表 */
.card-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.card-item {
  border-radius: 12px;
  padding: 26px 20px;
  display: flex;
  align-items: center;
  background-size: cover;
  background-position: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  text-align: left;
}

/* 动态背景图类名 */
.card-bg-0 {
  background-image: url("~@/assets/ai/ai1.png");
}

.card-bg-1 {
  background-image: url("~@/assets/ai/ai2.png");
}

.card-bg-2 {
  background-image: url("~@/assets/ai/ai3.png");
}

.card-bg-3 {
  background-image: url("~@/assets/ai/ai4.png");
}

.card-bg-4 {
  background-image: url("~@/assets/ai/ai5.png");
}

.card-text {
  color: #374151;
  font-weight: 500;
  font-size: 16px;
}

.card-text p:last-child {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}

.message-content {
  text-align: left;
}

/* 聊天区域 */
.chat-container {
  background: linear-gradient(
    90deg,
    rgba(92, 127, 246, 0.1) 0%,
    rgba(213, 242, 255, 0.1) 100%
  );
  border-radius: 16px;
  padding: 20px;
  margin-top: 15px;
}

.chat-message {
  display: flex;
  align-items: flex-start;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 12px;
}

.message-text {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 4px;
}

.message-text2 {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

/* 话题选择 */
.htTitle {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 20px 0 12px;
  text-align: left;
}

.topic-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-between;
}

.category {
  width: 48%;
  /* 双列布局 */
  background: #fff;
  padding: 15px;
  border-radius: 12px;
  box-sizing: border-box;
}

.category-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.htimg {
  width: 20px;
  height: 20px;
  margin-right: 6px;
}

.topic-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f3f3f3;
}

.topic-item:last-child {
  border-bottom: none;
}

.topic-text {
  font-weight: 500;
  font-size: 14px;
  color: #4b5563;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.arrow {
  width: 6px;
  height: 10px;
}

/* 消息列表 */
.chat-content {
  margin-top: 20px;
  margin-bottom: 80px;
  /* 留出录音按钮空间 */
}

.con-left {
  width: fit-content;
  max-width: 80%;
  background: #fff;
  padding: 16px;
  border-radius: 12px;
  margin-bottom: 16px;
  font-size: 16px;
  line-height: 1.5;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  text-align: left;
}

.ts {
  margin-top: 8px;
  font-size: 13px;
  color: #0091ff;
}

.con-right {
  width: fit-content;
  min-width: 80px;
  max-width: 60%;
  background: #549bee;
  color: #fff;
  padding: 10px 16px;
  border-radius: 12px 2px 12px 12px;
  margin-left: auto;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.con-right-yuyin {
  width: 16px;
  height: 16px;
  margin-left: 8px;
}

/* 录音按钮 */
.record-button {
  position: fixed;
  bottom: 10%;
  left: 5%;
  width: 90%;
  height: 50px;
  line-height: 50px;
  background: linear-gradient(90deg, #5ca3f6 0%, #549bee 100%);
  border-radius: 25px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  box-shadow: 0 4px 12px rgba(84, 155, 238, 0.3);
  z-index: 100;
  user-select: none;
  transition: all 0.2s;
}

.record-button.recording {
  background: #4caf50;
  transform: scale(1.02);
}

.record-button.cancel-mode {
  background: #ff9800;
}
</style>
